import { Component, Input } from "@angular/core";
import { ActionButtonDto } from "@api";
import { IonRouterOutlet } from "@ionic/angular";
import { NavigationService } from "src/app/services/navigation/navigation.service";

@Component({
  selector: "app-report-action-button",
  templateUrl: "./report-action-button.component.html",
  styleUrls: ["./report-action-button.component.scss"],
})
export class ReportActionButtonComponent {
  @Input() public actionButton: ActionButtonDto;

  public showMore: boolean = false;

  constructor(private readonly navigationService: NavigationService, private readonly routerOutlet: IonRouterOutlet) {}

  public handleClick(actionButton: ActionButtonDto): void {
    this.navigationService.handleNavigationTo(actionButton.actionLink, this.routerOutlet.nativeEl);
  }

  public toggleShowMore(): void {
    this.showMore = !this.showMore;
  }
}
